import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { DomainService } from '../../../services/admin/domain.service';

@Component({
  selector: 'app-loading-redirect',
  template: `
    <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; background-color: #f8f9fa; font-family: 'Montserrat', sans-serif;">
      <div style="width: 3.5rem; height: 3.5rem; border: 4px solid #ebe9f1; border-top: 4px solid #f3d30d; border-radius: 50%; animation: spinLoader 0.8s linear infinite;"></div>
      <style>
        @keyframes spinLoader {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }
      </style>
    </div>
  `
})
export class LoadingRedirectComponent implements OnInit {

  constructor(
    private domainService: DomainService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    await this.domainService.inicializarDominio();

    const domainInfo = this.domainService.getDomainInfo();

    if (domainInfo?.redireccionTiendaVirtual) {
      window.location.replace(domainInfo.redireccionTiendaVirtual);
      return;
    }

    if (this.domainService.esPrincipal()) {
      this.router.navigate(['/admin/management']);
      return;
    }

    this.router.navigate(['/error']);
  }
}
